import { ConfigurationService } from '../configuration/configuration.service';

export function sendBeacon(url: string, payload: string): void {
  const endpoint = new URL(url, ConfigurationService.getApi());

  if (navigator.sendBeacon) {
    navigator.sendBeacon(endpoint, payload);
    return;
  }

  fetch(endpoint.toString(), {
    body: payload,
    method: 'POST',
    keepalive: true,
  });
}
